import {HttpErrorResponse} from '@angular/common/http';

import {BDCPComparableBrotherProductsListResponse} from '../../../../models/comparable-brother-products-list-response.model';
import {BDCPProductDetails} from '../../../../models/product-details.model';
import {BDCPProductsListResponse} from '../../../../models/products-list-response.model';
import {BDCPShareService} from './../share.service';
import {BDModalService} from '@brother-apps/brother-dealerapp-shared-lib';
import {IBDCPProductsService} from './products.interface';
import {Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {MyHttpClient} from '../../../../../../../shared/services/my-http-client.service';

@Injectable()
export class BDCPProductsService extends IBDCPProductsService {

    private endpoint = '/brotherProducts/';

    public constructor(
        private httpClient: MyHttpClient,
        private share: BDCPShareService,
        private modalService: BDModalService
    ) {
        super();
    }

    public async getAll(): Promise<BDCPProductsListResponse> {
        throw new Error('Method not implemented.');
    }

    public async getBySearchValue(searchValue: string): Promise<BDCPProductsListResponse> {
        try {
            return await firstValueFrom(
                this.httpClient.get<BDCPProductsListResponse>(this.share.sharedModel?.apiUrl + '/products/', {
                    headers: {
                        'Authentication': 'Token ' + this.share.sharedModel.appPortalSecurityToken
                    },
                    params: {
                        'keywords': searchValue
                    }
                })
            );
        } catch (ex) {
            if (ex instanceof HttpErrorResponse) {
                const httpEx = <HttpErrorResponse>ex;
                if (httpEx.error.message) {
                    switch (<string>httpEx.error.message) {
                        case 'Result list is too long.':
                            this.modalService.open(
                                'Achtung',
                                'Zu Ihrer Anfrage gibt es eine zu große Menge an Ergebnissen. Bitte verfeinern Sie Ihre Suche.'
                            );
                            break;
                    }
                    if ((<string>httpEx.error.message).indexOf('401 Unauthorized') > -1) {
                        this.modalService.open(
                            'Achtung',
                            'ITScope Login ist fehlgeschlagen. Bitte prüfen Sie Ihre ITScope Zugangsdaten.'
                        );
                    }
                }
            }
            const response = new BDCPProductsListResponse();
            response.type = 'BROTHER';
            response.products = [];
            return response;
        }
    }

    public async getByCategory(category: string): Promise<BDCPProductsListResponse> {
        return await firstValueFrom(
            this.httpClient.get<BDCPProductsListResponse>(this.share.sharedModel?.apiUrl + '/brotherProducts/', {
                headers: {
                    'Authentication': 'Token ' + this.share.sharedModel.appPortalSecurityToken
                },
                params: {
                    'productCategory': category
                }
            })
        );
    }

    public async getByFilter(queryParams: { [key: string]: string | string[] }): Promise<BDCPProductsListResponse> {
        return await firstValueFrom(
            this.httpClient.get<BDCPProductsListResponse>(this.share.sharedModel?.apiUrl + '/brotherProducts/', {
                headers: {
                    'Authentication': 'Token ' + this.share.sharedModel.appPortalSecurityToken
                },
                params: queryParams
            })
        );
    }

    public async getComparableBrotherProducts(puid: string): Promise<BDCPComparableBrotherProductsListResponse> {
        return await firstValueFrom(
            this.httpClient.get<BDCPComparableBrotherProductsListResponse>(
                this.share.sharedModel?.apiUrl + '/comparableBrotherProducts/',
                {
                    headers: {
                        'Authentication': 'Token ' + this.share.sharedModel.appPortalSecurityToken
                    },
                    params: {
                        'puid': puid
                    }
                }
            )
        );
    }

    public async getDetails(sku: string): Promise<BDCPProductDetails> {
        try {
            return await firstValueFrom(
                this.httpClient.get<BDCPProductDetails>(this.share.sharedModel?.apiUrl + this.endpoint, {
                    headers: {
                        'Authentication': 'Token ' + this.share.sharedModel.appPortalSecurityToken
                    },
                    params: {
                        'sku': sku
                    }
                })
            );
        } catch (ex) {
            if (ex instanceof HttpErrorResponse) {
                const httpEx = <HttpErrorResponse>ex;
                if (httpEx.error.message) {
                    if ((<string>httpEx.error.message).indexOf('401 Unauthorized') > -1) {
                        this.modalService.open(
                            'Achtung',
                            'ITScope Login ist fehlgeschlagen. Bitte prüfen Sie Ihre ITScope Zugangsdaten.'
                        );
                    }
                }
            }
            return null;
        }
    }

    public async getStreetPrice(sku: string, ean: string): Promise<string> {
        try {
            let html = '';
            try {
                html = await firstValueFrom(
                    this.httpClient.get<string>(`https://cors-anywhere.herokuapp.com/https://geizhals.de?fs=${ean}&in=`)
                );
            } catch (ex) {
                html = ex.error.text;
            }
            const response = await firstValueFrom(
                this.httpClient.post(
                    this.share.sharedModel?.apiUrl + this.endpoint + 'streetPrices',
                    {
                        'productSKU': sku,
                        'geizhalsHTML': html
                            .replace(/&/g, '&amp;')
                            .replace(/"/g, '&quot;')
                            .replace(/'/g, '&#39;')
                            .replace(/</g, '&lt;')
                            .replace(/>/g, '&gt;')
                    }
                )
            );
            return response['lowestPrice'];
        } catch {
            return null;
        }
    }
}
